import { useMemo } from 'react'
import { LearnerObjectiveAccessCompactModel } from '@/api/models/aggregate'
import { COLLECTION_NO_VALUE } from '@/store/api/showcasesApi'
import { useAppSelector } from '@/store/hooks'
import { createFiltersSelector } from '@/store/slices/aggregatesSlice'

type FilterParams = {
  type: 'catalog' | 'enrolled'
  courses: LearnerObjectiveAccessCompactModel[]
}

export const useFilterCoursesByCollection = ({ type, courses }: FilterParams) => {
  const filters = useAppSelector((state) => createFiltersSelector(state, type))

  return useMemo(() => {
    const { collection: collectionFilter = [] } = filters || {}

    if (!collectionFilter.length) return courses

    const hasEmptyFilter = collectionFilter.includes(COLLECTION_NO_VALUE)
    const filterSet = new Set(collectionFilter)

    return courses.filter((course) => {
      const courseCollections = course.objective.showcases?.map((showcase) => showcase.id) || []

      if (hasEmptyFilter && !courseCollections.length) return true

      return courseCollections.some((id) => filterSet.has(id))
    })
  }, [courses, filters])
}
